// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlKZFcvUi89CWKon94lc{width:100%;height:100%;display:flex}.rv4MHXH8sUNIza73Yimx{background-color:var(--gray-a-15);border-radius:4px;margin-bottom:20px;padding:3.5px 8px;display:inline-block}.z2RRib6BNoIyKIjL85Gj{margin-bottom:20px}.XcwvSrJ9XWsCAN9hOVz5{padding:30px 0}.kVAqT5Bz4Bgr24PlR3W4{width:100%;max-width:620px;padding-bottom:0;padding-left:80px;padding-right:75px;overflow-y:auto}.Pj_q2Orvo7MMYXN7IQEw{position:relative}.FGCU0JZvYTAhFNfnnUef{border-left:1px solid var(--border-neutral-default);justify-content:center;padding-top:60px;padding-left:63px;padding-right:60px;display:flex}.MvNy5lzKAluL8LWnanlA{height:100%}.abNdQuG2W8A56zUanXqu{padding-top:30px}.EFSbooZUSxAUZiqNcoEG{margin-bottom:6px}.EFSbooZUSxAUZiqNcoEG:last-of-type{margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FlKZFcvUi89CWKon94lc`,
	"label": `rv4MHXH8sUNIza73Yimx`,
	"guidelineAlert": `z2RRib6BNoIyKIjL85Gj`,
	"box": `XcwvSrJ9XWsCAN9hOVz5`,
	"box__main": `kVAqT5Bz4Bgr24PlR3W4`,
	"boxMain": `kVAqT5Bz4Bgr24PlR3W4`,
	"box__isRelative": `Pj_q2Orvo7MMYXN7IQEw`,
	"boxIsRelative": `Pj_q2Orvo7MMYXN7IQEw`,
	"box__preview": `FGCU0JZvYTAhFNfnnUef`,
	"boxPreview": `FGCU0JZvYTAhFNfnnUef`,
	"loading": `MvNy5lzKAluL8LWnanlA`,
	"section": `abNdQuG2W8A56zUanXqu`,
	"section__box": `EFSbooZUSxAUZiqNcoEG`,
	"sectionBox": `EFSbooZUSxAUZiqNcoEG`
};
export default ___CSS_LOADER_EXPORT___;
